var _style, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUploadConfirmationDialogStep1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 154.1 114.2",
    style: {
      enableBackground: "new 0 0 154.1 114.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n.clonoseq-theme #Group_1798 .st0 {\n  fill: #67b8db;\n}\n\n.immunoseq-theme #Group_1798 .st0 {\n  fill: #e9903f;\n}\n\n#Group_1798 .st1 {\n  fill: #ffffff;\n}\n  ")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1798",
    transform: "translate(-567 -230)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1796",
    transform: "translate(567 230)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3030",
    className: "st0",
    d: "M38.1,49c-6.5,0-12.9,0-19.4,0c-0.5,0-1-0.1-1.4-0.4c-0.7-0.6-0.9-1.5-0.5-2.3 c0.3-0.7,0.6-1.3,0.9-2c2.6-5.7,5.2-11.4,7.8-17.1c0.3-0.7,0.7-1.3,1.3-1.8c0.7-0.6,1.6-0.9,2.6-0.9c5,0,10.1,0,15.1,0 c7.8,0,15.6,0,23.4,0c0.3,0,0.5,0,0.8,0c0.9,0.2,1.5,1,1.4,1.9c0,0.1,0,0.1,0,0.2c0,0.2-0.1,0.4-0.2,0.6c-2.9,6.3-5.8,12.6-8.7,19 c-0.3,0.8-0.9,1.6-1.6,2.1c-0.6,0.4-1.4,0.7-2.1,0.7C51,49,44.5,49,38.1,49z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3031",
    className: "st0",
    d: "M59.6,22.7h-0.3c-9.9,0-19.9,0-29.8,0c-2.3,0.1-4.3,1.5-5.3,3.6c-0.9,2.1-1.9,4.1-2.8,6.1 c-2,4.3-3.9,8.6-5.9,12.9c0,0.1-0.1,0.2-0.2,0.3v-0.2c0-10.1,0-20.2,0-30.3c0-1.3,0.8-2.4,2.1-2.7c0.2,0,0.5-0.1,0.7-0.1 c4,0,8,0,12,0c1.2-0.1,2.3,0.6,2.6,1.8c0.1,0.3,0.1,0.7,0.2,1c0,0.4,0,0.8,0,1.1c0,0.4,0.3,0.8,0.8,0.8c0.1,0,0.3,0,0.4,0h22.7 c0.6,0,1.3,0.1,1.8,0.5c0.6,0.4,1,1.2,1.1,2C59.6,20.6,59.6,21.6,59.6,22.7z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_3032",
    className: "st0",
    d: "M705.2,306.2c0-0.8,0-1.6,0-2.4c0-0.8-0.4-1.5-1-1.9c-0.5-0.4-1.2-0.5-1.8-0.5h-27.1 c-0.1,0-0.3,0-0.4,0c-0.4,0-0.8-0.4-0.8-0.8c0-0.4,0-0.7,0-1.1c0-0.3-0.1-0.7-0.2-1c-0.4-1.1-1.4-1.8-2.6-1.7c-4,0-7.9,0-11.9,0 c-0.2,0-0.5,0-0.7,0.1c-1.2,0.3-2.1,1.4-2.1,2.6c0,2.3,0,4.5,0,6.8c0,0,0,0,0,0v24.6c0,1.4,1.1,2.5,2.5,2.5l0,0h43.4 c1.4,0,2.5-1.1,2.5-2.5l0,0L705.2,306.2C705.2,306.2,705.2,306.2,705.2,306.2z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1797",
    transform: "translate(0 -11)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_204",
    className: "st0",
    cx: 648.8,
    cy: 326.1,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_198",
    className: "st0",
    cx: 606.8,
    cy: 311.8,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_200",
    className: "st0",
    cx: 620.8,
    cy: 326.1,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_194",
    className: "st0",
    cx: 606.8,
    cy: 297.8,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_202",
    className: "st0",
    cx: 634.8,
    cy: 326.1,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_203",
    className: "st0",
    cx: 641.8,
    cy: 326.1,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_197",
    className: "st0",
    cx: 606.8,
    cy: 318.8,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_199",
    className: "st0",
    cx: 613.8,
    cy: 326.1,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_205",
    className: "st0",
    cx: 606.8,
    cy: 326.1,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_193",
    className: "st0",
    cx: 606.8,
    cy: 304.8,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_201",
    className: "st0",
    cx: 627.8,
    cy: 326.1,
    r: 1.5
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_3033",
    className: "st1",
    d: "M610.2,259.5l1.5,1.2c1.6,1.2,3.1,2.4,4.7,3.6c0,0,0.1,0.1,0.1,0.1c0,2.9,0,5.8,0,8.8v0.1h-4.2 V268h-4.1v5.3h-4.3v-0.1c0-2.9,0-5.8,0-8.8c0,0,0-0.1,0.1-0.1C606.1,262.7,608.1,261.1,610.2,259.5L610.2,259.5z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadConfirmationDialogStep1);
export default __webpack_public_path__ + "static/media/UploadConfirmationDialog_Step1.e7e01bd8.svg";
export { ForwardRef as ReactComponent };